import ApplicationAdapter from "./application";

export default class ArchiveAdapter extends ApplicationAdapter {
  coalesceFindRequests = false;

  urlForFindRecord(id) {
    return `${this.apiBaseUri}/archive/details?username=${id}`;
  }

  urlForCreateRecord() {
    return `${this.apiBaseUri}/archive/create`;
  }

  urlForDeleteRecord(id) {
    return `${this.apiBaseUri}/archive/delete?username=${id}`;
  }
}
